<template>
    <a
        href="#youtube-video"
        @keydown.tab="tabKeydown"
        @click="startVideo"
        style="display: block; padding: 4px"
    >
        <div :class="responsiveClass">
            <Loader v-if="!youtubePlayerReady" />
            <div v-show="youtubePlayerReady && showVideo">
                <YouTube
                    :src="videoId"
                    :vars="playerVars"
                    width="100%"
                    ref="youtube"
                    @ready="youtubePlayerReady = true"
                    host="https://www.youtube-nocookie.com"
                />
            </div>
            <div
                v-if="!showVideo && youtubePlayerReady && !autoplay"
                class="youtube__thumbnail-container"
                @click="startVideo"
            >
                <div
                    class="youtube__thumbnail"
                    :style="{
                        'background-image': 'url(\'' + thumbnailUrl + '\')',
                    }"
                ></div>
                <img
                    class="play-icon play-icon--large"
                    src="@/assets/icons/play_icon.svg"
                />
            </div>
        </div>
    </a>
</template>

<script>
import { defineComponent } from 'vue';
import YouTube from 'vue3-youtube';
import Loader from '../components/Loader.vue';

export default defineComponent({
    name: 'YoutubeVideo',
    components: {
        Loader,
        YouTube,
    },
    props: {
        videoId: { type: String, required: true },
        thumbnailUrl: { type: String, required: true },
        autoplay: { type: Boolean, default: false },
        aspectRatio: { type: String, default: '4by3' },
    },
    data() {
        return {
            showVideo: false,
            youtubePlayerReady: false,
        };
    },
    created() {
        this.showVideo = this.autoplay;
    },
    computed: {
        playerVars() {
            return {
                autoplay: this.autoplay ? 1 : 0,
                origin: window.location.origin,
                rel: 0,
            };
        },
        responsiveClass() {
            // Dynamisk klasse basert på aspectRatio-prop
            return `embed-responsive embed-responsive-${this.aspectRatio}-youtube`;
        },
    },
    methods: {
        tabKeydown() {
            this.showVideo = true;
        },
        startVideo() {
            this.showVideo = true;
            const player = this.$refs.youtube.player;
            if (player.getPlayerState() === 1) {
                player.pauseVideo();
            } else {
                player.playVideo();
            }
        },
    },
});
</script>
